// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"264851e1","885":"14289027"}[chunkId] + ".chunk.js";
};